export const NOTIFICATION_TYPES = {
  APPROVAL_REQUEST: "APPROVAL_REQUEST",
  APPROVAL_GRANTED: "APPROVAL_GRANTED",
  APPROVAL_REJECTED: "APPROVAL_REJECTED",
  EVENT_REMINDER: "EVENT_REMINDER",
  SYSTEM_ALERT: "SYSTEM_ALERT",
  GENERAL: "GENERAL",
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.APPROVAL_REQUEST]: "Approval Request",
  [NOTIFICATION_TYPES.APPROVAL_GRANTED]: "Approval Granted",
  [NOTIFICATION_TYPES.APPROVAL_REJECTED]: "Approval Rejected",
  [NOTIFICATION_TYPES.EVENT_REMINDER]: "Event Reminder",
  [NOTIFICATION_TYPES.SYSTEM_ALERT]: "System Alert",
  [NOTIFICATION_TYPES.GENERAL]: "General",
};

export const NOTIFICATION_TYPE_CONFIG = {
  [NOTIFICATION_TYPES.APPROVAL_REQUEST]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.APPROVAL_REQUEST],
    accent: "#ff9800",
  },
  [NOTIFICATION_TYPES.APPROVAL_GRANTED]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.APPROVAL_GRANTED],
    accent: "#2e7d32",
  },
  [NOTIFICATION_TYPES.APPROVAL_REJECTED]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.APPROVAL_REJECTED],
    accent: "#d32f2f",
  },
  [NOTIFICATION_TYPES.EVENT_REMINDER]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.EVENT_REMINDER],
    accent: "#1976d2",
  },
  [NOTIFICATION_TYPES.SYSTEM_ALERT]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.SYSTEM_ALERT],
    accent: "#7b1fa2",
  },
  [NOTIFICATION_TYPES.GENERAL]: {
    label: NOTIFICATION_TYPE_LABELS[NOTIFICATION_TYPES.GENERAL],
    accent: "#455a64",
  },
};

export default NOTIFICATION_TYPES;
